const COLORS = {
    white: '#ffffff',
    black: '#000000',
    blue700: '#0070f0',
    blue600: '#0d8Bff',
    blue500: '#009bff',
    blue300: '#50c3Ff',
    blue200: '#96dcff',
    blue150: '#bde3ff',
    blue100: '#ebf5Ff',
    neutral900: '#0f1A24',
    neutral800: '#324253',
    neutral700: '#4e6174',
    neutral600: '#6b7F94',
    neutral500: '#9dadbe',
    neutral400: '#b6C4D3',
    neutral300: '#cfdae5',
    neutral200: '#e2Ebf3',
    neutral100: '#f1F5F9',
    purple700: '#8626fd',
    purple600: '#9641ff',
    purple500: '#a055Ff',
    purple300: '#aa91Ff',
    purple200: '#c8Beff',
    purple150: '#dddbff',
    purple100: '#f0F0Ff',
    orange700: '#d94D02',
    orange600: '#f55F00',
    orange500: '#ff7828',
    orange300: '#ffa064',
    orange200: '#ffcdb4',
    orange100: '#fff0Eb',
    green700: '#04AF33',
    green600: '#00d73C',
    green500: '#73eb5A',
    green300: '#a5f2b7',
    green200: '#befabe',
    green100: '#ebffeb',
    red700: '#e2062D',
    red600: '#f8153C',
    red500: '#f83B5D',
    red300: '#fb899E',
    red200: '#fee1E6',
    red100: '#fff0F3',
    poetryReading: '#9EB0CB',
};
module.exports = Object.assign({}, COLORS);
